<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <template v-slot:header>

            <div class="pull-left mt-2 mb-2"><strong>{{ header }}</strong></div>
            <b-button
              v-if="filters && filters.length"
              size="sm"
              variant="secondary"
              class="pull-right mt-1"
              @click="resetFilters"
            >Reset filters
            </b-button>

            <resource-actions :actions="actions" :endpoint="endpoint"/>

          </template>

          <resource-filters
            v-model="filters"
            v-if="filters && filters.length"
            :disabled="busy"
            class="mb-3"
          />
          {{ optionSelected }}
          <resource-table
            :endpoint="endpoint"
            :show-route="showRoute"
            v-model="filters"
            @inputActions="actions = $event"
            @onBusy="handleBusy"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import ResourceFilters from './ResourceFilters';
  import ResourceTable from './ResourceTable';
  import ResourceActions from "./ResourceActions";
  import {addData, getData, updateData} from '@/api';
  let timer = null;

  export default {
    props: {
    options:{
    default: ()=>[],
    type: Object/Array
  },
    endpoint: {}, showRoute: {}, header: {}},
    components: {ResourceActions, ResourceTable, ResourceFilters},
    methods: {
      handleBusy(state) {
        console.log('handleBusy', state);
        this.busy = state;
      },
      async getItem() {
      const item = await getData('groups/').then(response => response.data);
       item.data.forEach(element => {
         this.options.push({value:element.resource_key , text:element.resource_name })
       });
        console.log(this.options)

    },
      resetFilters() {
        this.filters.forEach((item, index) => {
          this.filters[index].value = null;
        });
      },
      storeFilters(value) {
        if (timer) clearTimeout(timer);

        timer = setTimeout(() => {
          const namespace = this.endpoint;

          localStorage.setItem(`${namespace}-filters`, JSON.stringify(value));
        }, 500);
      },
      autoLoadFilters() {
        const namespace = this.endpoint;

        const filters = localStorage.getItem(`${namespace}-filters`);

        if (filters) {
          this.filters = JSON.parse(filters);
        }
      },
    },
    data() {
      return {
        filters: [],
        actions: [],
        busy: false,
        optionSelected:''
      };
    },
    beforeMount() {
      this.autoLoadFilters();
       this.getItem()
    },
    watch: {
      filters: {
        handler(oldValue, newValue) {
          this.storeFilters(newValue);
        },
        deep: true,
      },
    },
  };
</script>


<style scoped>
  .selectGroup{
      text-align: right;
      right: 0px;
      position: absolute;
      display: inline-block;
      margin-right: 5px;
  }

  .selectGroupLabel{
      text-align: right;
      right: 0px;
      position: absolute;
      margin-left: -12px;
  }
  @media (max-width:768px) {
    .selectGroup{
      position: unset;
      padding: 0;
      margin-bottom: 8px;
    }
  }
</style>
